module.exports = __webpack_public_path__ + "img/vitte.80bde3c0.png";